import {routeNames} from "../shared/router/routeNames";
import {LoginPage} from "../pages/LoginPage/LoginPage";
import {AdminPage} from "../pages/AdminPage/AdminPage";

export const privateRoutes = [
  {
    // /admin/users, /admin/complexes, ...: the section open in the menu
    path: `${routeNames.ADMIN}/:section?`,
    exact: false,
    component: AdminPage
  },
]

export const publicRoutes = [
  {
    path: routeNames.LOGIN,
    exact: true,
    component: LoginPage
  },
]

